<section id="select-action">
  <ul class="action-list">
    <li class="action-list-item">
      <aside class="initial-action">
        <app-action-dull-input [label]="dataRulesService.actionOperators.DELETE"></app-action-dull-input>
        <app-action-warning-block [message]="warningMessage" [actionType]="actionType"></app-action-warning-block>
      </aside>
      <aside>
        <div class="message tip">
          <i class="material-icons notranslate">info</i>
          {{actionDescription}}
        </div>
      </aside>
    </li>
  </ul>
</section>
